function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2 14q0-3.27 1.6-6.02T8 3.6 14 2t6.02 1.6T24.4 8t1.6 6-1.6 6.02T20 24.4 14 26t-6.02-1.6T3.6 20 2 14zm6.52-4.67q-.24.37.12.65l2.06 1.57q.1.1.3.1.25 0 .4-.2.82-1.06 1.34-1.43.53-.38 1.34-.38.75 0 1.34.4t.58.93q0 .6-.3.95t-1.07.7q-1 .44-1.8 1.36T12 15.94v.56q0 .22.14.36t.36.14h3q.22 0 .36-.14t.14-.36q0-.3.34-.77t.85-.78q.5-.28.74-.44t.7-.52.7-.75.45-.93.2-1.3q0-1.37-.87-2.55t-2.17-1.8T14.32 6q-3.8 0-5.8 3.33zM12 21.5q0 .22.14.36t.36.14h3q.22 0 .36-.14t.14-.36v-3q0-.22-.14-.36T15.5 18h-3q-.22 0-.36.14t-.14.36v3z",
  className: ""
});

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    className: "icon svg-inline--fa fa-help fa-w-16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.41700498.svg";
export { ForwardRef as ReactComponent };